import { baseApi } from '@/store/api/baseApi';
import type {
  ForgotPasswordPayload,
  LoginPayload,
  ResetPasswordPayload,
  User,
  VerifyOtpPayload,
} from '@/types/auth';
import { normalizeUser } from '@/utils/user';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<User, LoginPayload>({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
      transformResponse: (response: User) => normalizeUser(response),
      invalidatesTags: ['Auth'],
    }),
    forgotPassword: builder.mutation<void, ForgotPasswordPayload>({
      query: (body) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body,
      }),
    }),
    verifyOtp: builder.mutation<void, VerifyOtpPayload>({
      query: (body) => ({
        url: '/otp/verify',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: builder.mutation<void, ResetPasswordPayload>({
      query: (body) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useForgotPasswordMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation,
} = authApi;
